import { ShipType } from '../../data/types/ship/ship-type';
import { System } from '../../data/types/system/system';
import { getSystemTechLevel } from '../solar-system/system-tech-level';
import { shipConfigs } from '../../config/ship/ship.configs';

export const isShipProducible = (system: System) => (
  shipType: ShipType,
): boolean => getSystemTechLevel(system) >= shipConfigs[shipType].minTechLevel;
